<ng-container>
    <h1 mat-dialog-title
        cdkDrag
        cdkDragRootElement=".cdk-overlay-pane"
        cdkDragHandle
        class="draggable-dialogue-header">
        {{this.Title}}
    </h1>

    <div mat-dialog-content
         class="dialog-content-div"
         style="max-height: 300px; display: flex; flex-direction: column; justify-content: center;">
        <app-form-field-wrapper [formField]="this.FormField"
                                [formInstance]="this.FormInstance"
                                [mode]="'instance'"
                                [readOnly]="false"
                                [(ngModel)]="FormInstanceElement"
                                [fieldIsInGrid]="false"
                                [fieldIsInGridCellEditor]="true"
                                [gridRowId]="this.GridRowId"
                                [gridColumnDefs]="this.GridColumnDefs"
                                (mimickedNgModelChange)="this.handleMimickedNgModelChange($event)"
                                (onInit)="this.gridColumnInit($event, this.FormField)"
                                (formStatusChanged)="handleValidityChange($event)"
                                (wrapperFormControlCreated)="this.handleWrapperFormControlCreated($event)"
                                (touched)="handleTouched($event)">
        </app-form-field-wrapper>
    </div>

    <div mat-dialog-actions class="grid-cell-editor">
        <button mat-flat-button
                color="primary"
                [disabled]="false"
                style=""
                (click)="this.applyEnteredValue()">
            Apply
        </button>

        <button mat-flat-button
                [disabled]="false"
                style=""
                (click)="this.cancel()">
            Cancel
        </button>
    </div>

</ng-container>
